import React, { useEffect } from "react";
import BangkokFirstLoad from "./functions/Bangkok.FirstLoad";
import BangkokBanner from "./render/Bangkok.Banner";
import BangkokList from "./render/Bangkok.List";
import MetaTags from "../../utils/useMetaTags";
import { ContextLanguage } from "../../context/Context.Language";

const BangkokMain = ({ programs, addons }) => {
  const { language } = React.useContext(ContextLanguage);
  useEffect(() => {
    BangkokFirstLoad();
  }, []);

  if (programs && addons) {
    return (
      <div id="scroll_bangkok">
        {language === "TH" ? (
          <MetaTags
            title="ที่ตั้ง - กรุงเทพ | My Laundry"
            description="เราให้บริการซักรีดและทำความสะอาดรองเท้าอย่างมืออาชีพในพื้นที่ส่วนใหญ่ของกรุงเทพ พร้อมส่งฟรีภายใน 12:00 น. ของวันถัดไป จองตอนนี้เลย!"
          />
        ) : (
          <MetaTags
            title="Locations - Bangkok | My Laundry"
            description="Our professional laundry service & shoe cleaning service is available almost everywhere in Bangkok! Enjoy FREE next-day delivery by 12:00! Book now!"
          />
        )}
        <BangkokBanner />
        <BangkokList programs={programs} data={addons} />
      </div>
    );
  } else {
    return null;
  }
};

export default BangkokMain;
